export const environment = {
  production: false,
  page: 'admin',
  companycode: "2",
  domain: 'https://dgpapi.aveapplications.com/',
  domainCourier: 'https://delivery.pla22agurus.com:2052/',
  url_s3: 'https://plazzagurus.s3.us-east-2.amazonaws.com/folder',

  authAPI: 'auth/v1/api/auth',
  masterAPI: 'master/v1/api',
  locationAPI: 'location/v1/api',
  itemAPI: 'item/v1/api',
  warehouseAPI: 'warehouse/v1/api',
  clientAPI: 'client/v1/api',
  bankAPI: 'bank/v1/api',
  orderAPI: 'delivery/v1/api',
  paymentAPI: 'payment/v1/api',

  emailAPI: 'https://delivery.pla22agurus.com:2052/',
  bankTlanAPI: 'https://validate.pla22agurus.com/', //banco atlantida
  comission: 15,

  addOrUpdateUserBps: true,
  addOrUpdateWarehouseBps: true,
  addOrUpdateItemBps: true,
};